// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetMarketTrandRequest,
  TGetMarketTrandModel,
  IMappers,
  TGetMarketTrandResponse_,
  TGetMarketTrandResponse,
  TGetMarketTrandResponse_1,
  TGetMarketTrandResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createGetMarketTrandModel(parameters: IGetMarketTrandRequest): TGetMarketTrandModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v1/get-market-trand/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetMarketTrandOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetMarketTrandRequest;
}

export async function fetchGetMarketTrand<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetMarketTrandOptions<TResponse200, TResponse400>): Promise<TGetMarketTrandResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetMarketTrandModel(parameters),
    config,
  )) as FetchResponse<TGetMarketTrandResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TGetMarketTrandResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TGetMarketTrandResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TGetMarketTrandResponse;
}
